import React                from "react";
import PropTypes            from "prop-types";
import { connect }          from "react-redux";
import Status               from "dashboard/dist/Core/Status";
import Utils                from "dashboard/dist/Utils/Utils";

// Components
import EditDialog           from "dashboard/dist/Components/EditDialog";
import InputField           from "dashboard/dist/Components/InputField";

// Actions
import {
    fetchLocality, fetchLocalityCreate, editLocality,
} from "Actions/Admin/Setup/LocalityActions";



/**
 * The Locality Edit Dialog
 */
class LocalityEdit extends React.Component {
    // The Initial Data
    initialData = {
        localityID : 0,
        provinceID : 0,
        countryID  : 0,
        name       : "",
        department : "",
        status     : Status.getID("ACTIVE"),
    }

    // The Current State
    state = {
        loading : false,
        data    : { ...this.initialData },
        errors  : {},
    }



    /**
     * Get the Data when the Element ID changes
     * @param {Object} prevProps
     * @returns {Void}
     */
    componentDidUpdate(prevProps) {
        const { open, edition, elemID, elem, fetchLocality, fetchLocalityCreate } = this.props;
        let loading = false;
        let data    = null;

        // Dialog Opens
        if (open && !prevProps.open) {
            data = { ...this.initialData };
            // Load new data
            if (elemID) {
                fetchLocality(elemID);
                loading = true;
            } else {
                fetchLocalityCreate();
                loading = true;
            }

        // Data Updated
        } else if (prevProps.edition !== edition) {
            if (elemID) {
                data = Utils.extend(this.initialData, elem);
            } else {
                data = { ...this.initialData };
            }
        }

        // Set the State
        if (data) {
            this.setState({ data, loading, errors : {} });
        }
    }

    /**
     * Handles the Input Change
     * @param {String} name
     * @param {*}      value
     * @returns {Void}
     */
    handleChange = (name, value) => {
        this.setState({
            data   : { ...this.state.data,   [name] : value },
            errors : { ...this.state.errors, [name] : ""    },
        });
    }

    /**
     * Handles the Submit
     * @returns {Promise}
     */
    handleSubmit = async () => {
        const { data, loading } = this.state;
        if (!loading) {
            this.setState({ loading : true, errors : {} });
            try {
                await this.props.editLocality(data);
                this.setState({ loading : false });
                this.props.onSubmit();
            } catch (errors) {
                this.setState({ loading : false, errors });
            }
        }
    }



    /**
     * Does the Render
     * @returns {Object}
     */
    render() {
        const { elemID, open, onClose, countries, provinces } = this.props;
        const { data, loading, errors                       } = this.state;

        return <EditDialog
            open={open}
            icon="locality"
            title={!!elemID ? "LOCALITIES_EDIT_TITLE" : "LOCALITIES_CREATE_TITLE"}
            error={errors.form}
            onSubmit={this.handleSubmit}
            onClose={onClose}
            isLoading={loading}
        >
            <InputField
                type="select"
                name="countryID"
                label="LOCALITIES_COUNTRY"
                value={data.countryID}
                error={errors.countryID}
                onChange={this.handleChange}
                options={countries}
                withNone
                isRequired
            />
            <InputField
                type="select"
                name="provinceID"
                label="LOCALITIES_PROVINCE"
                value={data.provinceID}
                error={errors.provinceID}
                onChange={this.handleChange}
                options={data.countryID ? provinces[data.countryID] || [] : []}
                withNone
                isRequired
            />
            <InputField
                name="name"
                label="LOCALITIES_ITS_NAME"
                value={data.name}
                error={errors.name}
                onChange={this.handleChange}
                isRequired
            />
            <InputField
                name="department"
                label="LOCALITIES_ITS_DEPARTMENT"
                value={data.department}
                error={errors.department}
                onChange={this.handleChange}
            />
            <InputField
                type="select"
                name="status"
                label="GENERAL_STATUS"
                value={data.status}
                error={errors.status}
                onChange={this.handleChange}
                options={Status.getFemSelect()}
                withNone
                isRequired
                shrinkLabel
            />
        </EditDialog>;
    }



    /**
     * The Property Types
     * @typedef {Object} propTypes
     */
    static propTypes = {
        fetchLocality       : PropTypes.func.isRequired,
        fetchLocalityCreate : PropTypes.func.isRequired,
        editLocality        : PropTypes.func.isRequired,
        open                : PropTypes.bool.isRequired,
        onClose             : PropTypes.func.isRequired,
        onSubmit            : PropTypes.func.isRequired,
        edition             : PropTypes.number.isRequired,
        countries           : PropTypes.array.isRequired,
        provinces           : PropTypes.object.isRequired,
        elem                : PropTypes.object.isRequired,
        elemID              : PropTypes.number,
    }

    /**
     * Maps the State to the Props
     * @param {Object} state
     * @returns {Object}
     */
    static mapStateToProps(state) {
        return {
            edition   : state.locality.edition,
            countries : state.locality.countries,
            provinces : state.locality.provinces,
            elem      : state.locality.elem,
        };
    }
}

export default connect(LocalityEdit.mapStateToProps, {
    fetchLocality, fetchLocalityCreate, editLocality,
})(LocalityEdit);
